/**
 * Grup pengguna yang sedang masuk, dibaca dari localStorage.
 *
 * Hanya untuk menentukan TAMPILAN (menu, tombol, halaman awal). Hak akses
 * yang sesungguhnya diputuskan server; mengubah localStorage tidak membuka
 * data apa pun.
 */
export const GRUP = Object.freeze({
  OWNER: 'Owner',
  ADMIN_EVENT: 'Event PIC',
  BENDAHARA: 'Bendahara',
});

export function grupPengguna() {
  try {
    const nama = JSON.parse(localStorage.getItem('user') || '{}').group?.name || '';
    return nama === 'Admin' ? GRUP.OWNER : nama;
  } catch (e) {
    return '';
  }
}

export const isOwner = () => grupPengguna() === GRUP.OWNER;
export const isBendahara = () => grupPengguna() === GRUP.BENDAHARA;
export const isPanitia = () => [GRUP.OWNER, GRUP.ADMIN_EVENT].includes(grupPengguna());

/** Halaman pertama setelah masuk. */
export function halamanAwal() {
  if (isBendahara()) return '/admin/keuangan';
  return isPanitia() ? '/admin' : '/admin/turnamen-saya';
}

/** Alamat panel yang boleh dibuka bendahara. */
export function bolehDibukaBendahara(path) {
  return /^\/admin\/(keuangan|payment)(\/|$)/.test(path);
}
